import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, UserDealer } from '../../../shared/interfaces/user.interfaces';
import { Observable } from 'rxjs';

const basePath = '/user/dealer';

@Injectable({
  providedIn: 'root'
})
export class UserDealerService {

  constructor(
    private http: HttpClient
  ) { }

  // Allows users from dealer 1 to associate themselves with any dealer.
  addSelfToDealer(dealerId: number) {
    return this.http.post(`${basePath}/${dealerId}`, {});
  }

  // Allows users from dealer 1 to remove themselves from any dealer.
  removeSelfFromDealer(dealerId: number) {
    return this.http.delete(`${basePath}/${dealerId}`);
  }

}
